import { User } from '../components/UserTable';

const ADDRESS_PREFIX = "http://localhost:8080/api";

export async function fetchPlayerCount(): Promise<number> {
  console.log("fetchPlayerCount triggered");
  const res = await fetch(`${ADDRESS_PREFIX}/player-count`);
  return await res.json() as number;
};

export async function fetchUserTable(): Promise<User[]> {
  console.log("fetchUserTable triggered");
  const res = await fetch(`${ADDRESS_PREFIX}/users`)
  return await res.json() as User[];
}